import utils from '../../../utils/index';

let paletteConverter = function (str, startIndex) {
    let arr = str.split(', ');

    let results = arr.map((item, i) => {
        let id = (startIndex || 1) + i;

        let itemParts = item.split('--');
        let name = itemParts[0];
        let hexColor = '#' + itemParts[1];
        let color = utils.hexToRgb(hexColor);

        return {
            id,
            name,
            color,
        }
    });

    return results;
};

export default paletteConverter;























